<template>
    <article class="container">
        <div class="triangle"></div>
        <div class="about_logo">
            <img src="../assets/a_pro.png" alt="穎業科技" />
            <img src="../assets/a_cp.png" alt="channelpro" />
        </div>
        <div class="about_content">
            <h2> 關於穎業(ChannelPro CO.,LTD.)</h2>
            <h2>[資通訊專業與AI語音客服的開發]</h2>
            <h4>「我們的動力，來自於您的需求」</h4>
            <p class="indent-2">
                穎業科技成立於 2006 年，憑藉著深耕資通訊領域近 20 年的紮實根基，我們發展出一套兼具<br/>
                <span class="focus">資訊專業</span>與
                <span class="focus">電信技術</span>的雙重核心競爭力。由專精資訊及電信( CTI - Computer Telephony<br />
                Integrated) 的技術團隊組成，我們具備高度的系統開發能力，致力於為客戶提供最精確的客製化<br />服務。
            </p>
            <h3>核心優勢：AI 技術與數位轉型</h3>
            <p>在 AI 浪潮下，穎業科技展現了強大的研發與整合經驗：</p>
            <ul>
                <li><span class="title">AI - Linker 產品系列：</span>專為企業導入 <span class="focus">AI 電話語音客服</span>而生。透過完善的電話語音平台，完<br />成地端及雲端的 AI串接整合，協助客戶實現語音自動化服務，提升企業溝通效率並降低營運<br />負擔。</li>
                <li><span class="title">數位化營運優勢：</span>公司內部全面採用<span class="focus">自行開發的 CRM 系統</span>，完美實現營運數位化，確保專<br />案管理的高效與透明度。</li>
                <li><span class="title">高度客製化承諾：</span>我們極度重視客戶反應，深知客戶的時間與金錢皆必須珍視，因此提供量<br />身打造、符合實際需求的智慧系統。</li>
            </ul>
            <h3>服務網點：全台即時回應</h3>
            <p>為確保服務的即時性，我們的服務網路遍布台灣<span class="focus">北、中、南</span>各地。無論客戶位於何處，皆能<br />獲得最快速的技術支援與維護服務。</p>
            <h3>CTiSS系列產品</h3>
            <ul>
                <li><span class="title title_blue">Contact Center：</span>提供完整的客服中心模組，因應不同產業客服需求。</li>
                <li><span class="title title_blue">AI Linker：</span>提供AI整合應用，完成企業導入AI客服之服務。</li>
                <li><span class="title title_blue">Information Center：</span>提供多元化的通告模組，支援企業訊息通告需求。</li>
                <li><span class="title title_blue">CMS：</span>支援IOT訊息匯集及即時的訊息通告，有效提供企業營運效率。</li>
            </ul>
        </div>
        <div class="bar bar1"></div>
        <div class="bar bar2"></div>
        <div class="bar bar3"></div>
        <div class="bar bar4"></div>
        <div class="bar bar5"></div>
        <div class="bar bar6"></div>
        <div class="bar bar7"></div>
    </article>
</template>




<script>
export default {
    layout: 'frontend'
};
</script>




<style scoped>
.container {
    height: 100%;
    width: 100%;
    min-height: 40vh;
    /* 漸層背景 */
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+1,d7effc+39,d7effc+61,ffffff+100 */
    background: #ffffff; /* Old browsers */
    background: -moz-linear-gradient(
        left,
        #ffffff 1%,
        #d7effc 40%,
        #d7effc 60%,
        #ffffff 100%
    ); /* FF3.6-15 */
    background: -webkit-linear-gradient(
        left,
        #ffffff 1%,
        #d7effc 40%,
        #d7effc 60%,
        #ffffff 100%
    ); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(
        to right,
        #ffffff 1%,
        #d7effc 40%,
        #d7effc 60%,
        #ffffff 100%
    ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#ffffff',GradientType=1 ); /* IE6-9 */
    position: relative;
    display: flex;
    justify-content: space-around;
}
.triangle {
    position: absolute;
    left: 0;
    top: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 200px 450px 0 0;
    border-color: #fff transparent transparent transparent;
}
.container > .about_logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 7%;
    margin-left: 5%;
}
.container > .about_logo > img {
    margin: 5% 5%;
    width: 60%;
}
.container > .about_content {
    z-index: 100;
}
.container > .about_content > h1 {
    font-size: 2.5em;
    font-weight: 400;
    letter-spacing: 0.1em;
    margin-bottom: 0;
    margin-top: 20px;
}
.container > .about_content > h2 {
    font-size: 2em;
    word-spacing: 0.5em;
    letter-spacing: 0.1em;
    line-height: 0.8em;
    font-weight: 400;
    margin-top: 10px;
}
.container > .about_content > p {
    margin-top: 3%;
    font-size: 1.2em;
    line-height: 1.6em;
}
.bar {
    z-index: 0;
    position: absolute;
    height: 20px;
    border-radius: 10px;
    background-color: #fff;
}
.bar1 {
    width: 40px;
    right: 10%;
    top: 2%;
}
.bar2 {
    width: 70px;
    right: 15%;
    top: 5%;
}
.bar3 {
    width: 100px;
    right: 8%;
    top: 11%;
}
.bar4 {
    width: 40px;
    top: 15%;
    right: 18%;
}
.bar5 {
    width: 100px;
    left: 32%;
    top: 75%;
}
.bar6 {
    width: 70px;
    left: 38%;
    top: 80%;
}
.bar7 {
    width: 40px;
    left: 35%;
    top: 85%;
}

ul {
    li {
        font-size: 1.2em;
        .title {
            font-weight: bolder;
        }

        .title_blue {
            color: #0000ff;
        }
    }
}

h2 {
    color: #0000ff;
    font-weight: bolder!important;
}

h3 {
    font-weight: bolder!important;
}

h4 {
    color: #990000;
}

.focus {
    font-weight: bolder;
}


.indent-2 {
    text-indent: 2em;
}
@media screen and (max-width: 1217px) {
    .container > .about_logo {
        display: none;
    }
    .container > .about_content {
        margin: 0 5%;
    }
    .container > .about_content > h1 {
        font-size: 2em;
        margin-bottom: 0;
    }
    .container > .about_content > h2 {
        font-size: 1.5em;
        margin-top: 0;
        letter-spacing: 0.02em;
    }
    .container > .about_content > p {
        font-size: 0.9em;
    }
    .triangle {
        border-width: 100px 230px 0 0;
    }
    .bar {
        height: 10px;
        border-radius: 5px;
    }
    .bar1 {
        display: none;
    }
    .bar2 {
        display: none;
    }
    .bar3 {
        right: 38%;
    }
    .bar4 {
        right: 48%;
    }
    .bar5 {
        left: 62%;
    }
    .bar6 {
        left: 68%;
    }
    .bar7 {
        left: 65%;
    }
}
</style>
